import adjectives from "../adjectives.json";
import nouns from "../nouns.json";

// Generate random username: AdjectiveNoun.randomnumber
export function generateRandomUsername(): string {
  const randomAdjective = adjectives[Math.floor(Math.random() * adjectives.length)];
  const randomNoun = nouns[Math.floor(Math.random() * nouns.length)];
  const randomNumber = Math.floor(Math.random() * 10000); // 0-9999
  
  // Capitalize first letter of each word
  const capitalizeFirst = (str: string) => str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  
  return `${capitalizeFirst(randomAdjective)}${capitalizeFirst(randomNoun)}.${randomNumber}`;
}

// Split username into text and number parts
export function getUsernameParts(fullUsername: string) {
  const parts = fullUsername.split('.');
  const textPart = parts[0] || fullUsername;
  const numberPart = parts[1] || '';
  return { textPart, numberPart };
}
